module.exports = __webpack_public_path__ + "static/media/beaconHome-320w.6c5968b6.jpg";